// extracted by mini-css-extract-plugin
module.exports = {"DefaultPageLayout":"DefaultLayout_DefaultPageLayout__1WHOv"};